import { render, staticRenderFns } from "./FactFindEmployments.vue?vue&type=template&id=23c0b1df&"
import script from "./FactFindEmployments.vue?vue&type=script&lang=ts&"
export * from "./FactFindEmployments.vue?vue&type=script&lang=ts&"
import style0 from "./FactFindEmployments.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports